<template>
  <span style="white-space:nowrap;">
    <FormattedNumber :class="klasse()"
                   v-model:value="attribute.ref.value" 
                   v-bind="$attrs"
                   :readOnly="isReadOnly" 
                   :format="format ?? metadataFormat()"
                   :setClassOnNegative="negativeClass()"/>
    <span class="numberunit" v-if="unit()" style="margin-left:5px;">{{unit()}}</span>
  </span>
</template>

<script>

import Attribute from "../../xmlrdb-data/Attribute"
import FormattedNumber from "../base/FormattedNumber.vue"
export default {
  inheritAttrs:false,
  name: "numberField",
  props: {
    attribute: Attribute,
    isReadOnly: Boolean,
    format: String
  },
  components: {
    FormattedNumber
  },
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  // clickableAttributeLabel: true, 
  clickableContainer: true,
  setup(props){
    
    
    return {
      unit() {
        return props.attribute.metadata.tagValueByName("Unit");
      },
      klasse() {
        if (props.attribute.metadata.name().endsWith("_EURO")) {
          return "euroInput";
        }
        else if (props.attribute.metadata.name().endsWith("_PROZENT") ||
                props.attribute.metadata.name().endsWith("_PROZ")) {
          return "prozentInput";
        }
      },
    //  attribute : props.attribute
      metadataFormat: function(){
        let formatString;
        let attrName = props.attribute.metadata.name();
        const isEuro = attrName.endsWith("_EURO");
        if (isEuro) {
          formatString = "0,0";
        }

        let isProz = attrName.endsWith("_PROZ") || attrName.endsWith("_PROZENT");
        if (isProz) {
          formatString = "0,0.00";
        }

        let tag = props.attribute.metadata.tagValueByName("dezimalStellen");
        if(tag){
          const dezNumber = parseInt(tag);
          formatString = "0,0";
          if(dezNumber > 0) formatString += ".";
          for(let i = 0; i < dezNumber; i++){
            formatString += "0";
          }
        }
        else if ((tag = props.attribute.metadata.tagValueByName("format")) ?? false ) {
          formatString = tag;
        }
        return formatString;// formatString;
      },
      negativeClass() {
        const negativeClassTag = props.attribute.metadata.tagByName("setClassOnNegative");
        if (negativeClassTag) {
          // @ts-ignore
          if (typeof negativeClassTag.value === 'string' && negativeClassTag.value.trim().length > 0) {
            return negativeClassTag.value
          }
          return true;
        }
        
      }
    }
      
  }
}

</script>

<style>
.euroInput {
  width: 7em;
}
.prozentInput {
  width: 4em;
}
</style>